// 认证/课程 考试
export const TEST_TYPE = {
    TYPES: [
        { value: 1, label: '单选题' },
        { value: 2, label: '多选题' },
        { value: 3, label: '判断题' }
    ],
    DIFFICULTY: [
        { value: 1, label: '入门' },
        { value: 2, label: '中等' },
        { value: 3, label: '困难' },
        { value: 0, label: '无' }
    ],
    STATUS: [
        { value: 1, label: '已发布' },
        { value: 0, label: '未发布' },
    ],
}
export const QUESTIONS_TYPE = {
    CLASSIFY: [
        // {value: 1, label: '课程考试'},
        { value: 2, label: '服务安全规范' },
        { value: 3, label: '服务能力' },
    ],
    CATEGORY: [
        { value: 1, label: '安全规范' },
        { value: 2, label: '能力测评' },
        { value: 3, label: '工艺' },
    ],
    CATION: [
        { value: 1, label: '无认证' },
        { value: 2, label: '考试认证' },
        {value: 3, label: '原厂认证'}
    ],
}
export const COUPONS_TYPE = {
    COUPONTYPE: [
        { value: 1, label: '发单优惠券' },
        { value: 2, label: '课程优惠券' },
        { value: 3, label: '通用类型优惠券' },
    ],
    GIVEOUTMODE: [
        { value: 1, label: '系统发放' },
        { value: 2, label: '手动领取' },
        { value: 3, label: '活动触发' },
    ],
    COUPONMODE: [
        { value: 1, label: '满减' },
        { value: 2, label: '折扣' },
        { value: 3, label: '立减' },
    ],
}
export const MESSAGE_TYPE = {
    MESSAGEEBOXTYPE: [
        { value: 1, label: '通用类型' },
        { value: 2, label: '活动类型' }
    ],
    FREQUENCY: [
        { value: 1, label: '仅首次登陆' },
        { value: 2, label: '每天' },
        { value: 3, label: '每周' },
        { value: 4, label: '每半月' },
        { value: 5, label: '每月' },
        { value: 6, label: '仅弹一次' },
    ],
    SITE: [
        { value: 1, label: 'APP' },
        { value: 2, label: 'PC' },
        { value: 3, label: '微信站' },
    ],
}
export const PERIOD = [
    { value: 1, label: '一年' },
    { value: 2, label: '二年' },
    { value: 3, label: '三年' },
    { value: 4, label: '四年' },
    { value: 5, label: '五年' },
]
export const SUBSIDY = [
    { value: 1, label: '无补助' },
    // { value: 2, label: '实报实销' },
    { value: 3, label: '速派规则' },
    { value: 4, label: '固定补助' },
]

export const RECOMMEND_TYPE = {
    CERTIFICATION: [
        {value: -1, label: '无认证'},
        {value: 0, label: '未认证'},
        {value: 1, label: '原厂认证'},
        {value: 4, label: '实操认证'},
        {value: 2, label: '考试认证'}
    ]
}